import { h } from 'preact'

const Block = props => {
  const { children, alt, style } = props
  return (
    <div
      {...{ ...props, children: undefined, alt: undefined }}
      style={{
        padding: '40px 0',
        background: alt ? '#e6e6e6' : undefined,
        ...style,
      }}
    >
      <div
        style={{
          position: 'relative',
          maxWidth: 960,
          margin: '0 auto',
        }}
      >
        {children}
      </div>
    </div>
  )
}
export default Block



// WEBPACK FOOTER //
// ./components/layout/Block.js